import React from 'react';

import { useIntl } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Pressable, xcss } from '@atlaskit/primitives';
import { components } from '@atlaskit/select';
import { N0, N40 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import ClearFilterButton from '../../../clear-filter-button';

import { i18n } from './messages';

const clearFilterOptionsButtonStyles = xcss({
	background: token('color.background.input', N0),
	color: 'color.text.subtle',
	border: 'none',
	paddingLeft: 'space.250',
	font: 'inherit',
	cursor: 'pointer',
	outline: 'inherit',
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	height: '36px',
	width: '100%',

	':hover': {
		backgroundColor: 'color.background.input.hovered',
	},

	':disabled': {
		color: 'color.text.accent.gray',
		cursor: 'default',
	},
});

type ClearFilterOptionsButtonProps = {
	onClick: () => void;
	children: string;
};

const ClearFilterOptionsButton = ({ onClick, children }: ClearFilterOptionsButtonProps) => {
	return (
		<Pressable onClick={onClick} xcss={clearFilterOptionsButtonStyles}>
			{children}
		</Pressable>
	);
};

const menuFooterStyles = xcss({
	borderTop: `${token('color.border', N40)} solid ${token('border.width')}`,
});

export const MenuListWithClearFilterOptionLabel = (props: any): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<>
			<components.MenuList {...props} />
			<Box xcss={menuFooterStyles}>
				{props.selectProps.canClearFilter && (
					<ClearFilterOptionsButton onClick={() => props.selectProps.onClearOptions()}>
						{formatMessage(i18n.searchClearFilterLabel)}
					</ClearFilterOptionsButton>
				)}
			</Box>
		</>
	);
};

export const MenuListWithoutClearFilterOptionLabel = (props: any): React.JSX.Element => {
	return (
		<>
			<components.MenuList {...props} />
			<Box xcss={menuFooterStyles}>
				{props.selectProps.canClearFilter && (
					<ClearFilterButton onClick={() => props.selectProps.onClearOptions()} />
				)}
			</Box>
		</>
	);
};
